<template>
  <div class="container">
    <div v-if="isLoading" class="loading-screen">
      <div class="spinner"></div>
      <p>جاري التحميل...</p>
    </div>

    <h1 class="text-center mb-4"> قائمة مناظرات سلك الإطارات</h1>

    <div class="table-responsive">
      <table class="custom-table">
        <thead>
          <tr>
            <th>رمز المناظرة</th>
            <th>الخطة</th>
            <th>عدد الخطط</th>
            <th>مركز العمل</th>
            <th>المستوى التعليمي والاختصاص</th>
            <th>التسجيل</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>25/01</td>
            <td>مهندس</td>
            <td>01</td>
            <td>بنزرت</td>
            <td>الشهادة الوطنية لمهندس في الإعلامية أو الشهادة الوطنية لمهندس في الإعلامية اختصاص برمجيات</td>
            <td>
              <router-link to="/formcom" class="register-btn" @click.prevent="setExamId('25/01')">
                <i class="fas fa-user-plus"></i> التسجيل
              </router-link>
            </td>
          </tr>
          <tr>
            <td>25/02</td>
            <td>مهندس</td>
            <td>02</td>
            <td>بنزرت</td>
            <td>الشهادة الوطنية لمهندس في الإعلامية أو الشهادة الوطنية لمهندس في الإعلامية اختصاص شبكات</td>
            <td>
              <router-link to="/formcom" class="register-btn" @click.prevent="setExamId('25/02')">
                <i class="fas fa-user-plus"></i> التسجيل
              </router-link>
            </td>
          </tr>
          <tr>
            <td>25/03</td>
            <td>إطار</td>
            <td>03</td>
            <td>بنزرت</td>
            <td>شهادة الماجستير في المالية أو المحاسبة (ماجستير مهني أو ماجستير بحث)</td>
            <td>
              <router-link to="/formcom" class="register-btn" @click.prevent="setExamId('25/03')">
                <i class="fas fa-user-plus"></i> التسجيل
              </router-link>
            </td>
          </tr>
          <tr>
            <td>25/04</td>
            <td>إطار</td>
            <td>01</td>
            <td>بنزرت</td>
            <td>شهادة الماجستير في المراقبة والتدقيق (ماجستير مهني أو ماجستير بحث)</td>
            <td>
              <router-link to="/formcom" class="register-btn" @click.prevent="setExamId('25/04')">
                <i class="fas fa-user-plus"></i> التسجيل
              </router-link>
            </td>
          </tr>
          <tr>
            <td>25/05</td>
            <td>مهندس</td>
            <td>01</td>
            <td>بنزرت</td>
            <td>الشهادة الوطنية لمهندس اختصاص instrumentation et maintenance industrielle</td>
            <td>
              <router-link to="/formcom" class="register-btn" @click.prevent="setExamId('25/05')">
                <i class="fas fa-user-plus"></i> التسجيل
              </router-link>
            </td>
          </tr>
          <tr>
            <td>25/06</td>
            <td>مهندس</td>
            <td>02</td>
            <td>بنزرت</td>
            <td>الشهادة الوطنية لمهندس اختصاص Electrique</td>
            <td>
              <router-link to="/formcom" class="register-btn" @click.prevent="setExamId('25/06')">
                <i class="fas fa-user-plus"></i> التسجيل
              </router-link>
            </td>
          </tr>
          <tr>
            <td>25/07</td>
            <td>مهندس</td>
            <td>01</td>
            <td>بنزرت</td>
            <td>الشهادة الوطنية لمهندس اختصاص Génie des matériaux</td>
            <td>
              <router-link to="/formcom" class="register-btn" @click.prevent="setExamId('25/07')">
                <i class="fas fa-user-plus"></i> التسجيل
              </router-link>
            </td>
          </tr>
          <tr>
            <td>25/08</td>
            <td>مهندس</td>
            <td>03</td>
            <td>بنزرت</td>
            <td>الشهادة الوطنية لمهندس اختصاص ميكانيك</td>
            <td>
              <router-link to="/formcom" class="register-btn" @click.prevent="setExamId('25/08')">
                <i class="fas fa-user-plus"></i> التسجيل
              </router-link>
            </td>
          </tr>
          <tr>
            <td>25/09</td>
            <td>مهندس</td>
            <td>02</td>
            <td>بنزرت</td>
            <td>الشهادة الوطنية لمهندس اختصاص هندسة كيميائية والاساليب</td>
            <td>
              <router-link to="/formcom" class="register-btn" @click.prevent="setExamId('25/09')">
                <i class="fas fa-user-plus"></i> التسجيل
              </router-link>
            </td>
          </tr>
          <tr>
            <td>25/10</td>
            <td>مهندس</td>
            <td>01</td>
            <td>بنزرت</td>
            <td>الشهادة الوطنية لمهندس في الهندسة المدنية</td>
            <td>
              <router-link to="/formcom" class="register-btn" @click.prevent="setExamId('25/10')">
                <i class="fas fa-user-plus"></i> التسجيل
              </router-link>
            </td>
          </tr>
          <tr>
            <td>25/11</td>
            <td>مهندس</td>
            <td>02</td>
            <td>بنزرت</td>
            <td>الشهادة الوطنية لمهندس في الهندسة الصناعية</td>
            <td>
              <router-link to="/formcom" class="register-btn" @click.prevent="setExamId('25/11')">
                <i class="fas fa-user-plus"></i> التسجيل
              </router-link>
            </td>
          </tr>
          <tr>
            <td>25/12</td>
            <td>إطار</td>
            <td>01</td>
            <td>بنزرت</td>
            <td>شهادة الماجستير في الاحصاء أو تحليل المعطيات (ماجستير مهني أو ماجستير بحث)</td>
            <td>
              <router-link to="/formcom" class="register-btn" @click.prevent="setExamId('25/12')">
                <i class="fas fa-user-plus"></i> التسجيل
              </router-link>
            </td>
          </tr>
          <tr>
            <td>25/13</td>
            <td>إطار</td>
            <td>01</td>
            <td>بنزرت</td>
            <td>شهادة الماجستير في الميتورولوجيا وهندسة الجودة</td>
            <td>
              <router-link to="/formcom" class="register-btn" @click.prevent="setExamId('25/13')">
                <i class="fas fa-user-plus"></i> التسجيل
              </router-link>
            </td>
          </tr>
          <tr>
            <td>25/14</td>
            <td>إطار</td>
            <td>01</td>
            <td>بنزرت</td>
            <td>شهادة الماجستير (ماجستير مهني أو ماجستير بحث) أو الشهادة الوطنية لمهندس في الالكتروميكانيك</td>
            <td>
              <router-link to="/formcom" class="register-btn" @click.prevent="setExamId('25/14')">
                <i class="fas fa-user-plus"></i> التسجيل
              </router-link>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>


<script>
export default {
  name: "RecruitmentTable1",
  data() {
    return {
      isLoading: true
    };
  },
  mounted() {
    setTimeout(() => {
      const loadingScreen = document.querySelector('.loading-screen');
      if (loadingScreen) {
        loadingScreen.style.transition = 'opacity 0.8s ease';
        loadingScreen.style.opacity = '0';
        setTimeout(() => {
          this.isLoading = false;
        }, 800);
      }
    }, 2000);
  },
  methods: {
    setExamId(id) {
      localStorage.setItem('examId', id);
      console.log('ID saved in localStorage:', id); // باش تشوف القيمة مباشرة
      this.$router.push('/formcom');
    }
  }
};
</script>

<style scoped>
.container {
  direction: rtl;
  padding: 20px;
  font-family: Arial, sans-serif;
  background: #f4f4f4;
  min-height: 100vh;
}
.loading-screen {
  position: fixed;
  inset: 0;
  background: linear-gradient(135deg, #0055a5, #66a3ff);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: white;
  z-index: 9999;
}
.spinner {
  width: 50px;
  height: 50px;
  border: 4px solid rgba(255,255,255,0.3);
  border-top: 4px solid #ffd700;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 20px;
}
@keyframes spin { to { transform: rotate(360deg); } }

h1 { text-align: center; margin-bottom: 20px; }
.table-responsive { overflow-x: auto; }

.custom-table {
  width: 100%;
  border-collapse: collapse;
  background: #fff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
}
.custom-table th,
.custom-table td {
  border: 1px solid #ccc;
  padding: 10px;
  vertical-align: top;
  text-align: center;
}
.custom-table th {
  background: #0055a5;
  color: white;
  font-weight: bold;
}
.custom-table tbody tr:nth-child(even) {
  background: rgba(0, 85, 165, 0.05);
}
.custom-table tbody tr:hover {
  background: #e6f0ff;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,85,165,0.2);
  transition: all 0.3s ease;
}

.register-btn {
  display: inline-block;
  background: linear-gradient(45deg, #0055a5, #ffd700);
  color: #fff;
  font-weight: 700;
  padding: 10px 20px;
  border-radius: 12px;
  text-decoration: none;
  box-shadow: 0 5px 15px rgba(0, 85, 165, 0.3);
  transition: all 0.4s ease;
  position: relative;
  overflow: hidden;
}
.register-btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 25px rgba(0, 85, 165, 0.4);
  text-decoration: none;
}
.register-btn::after {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.2);
  transform: skewX(-25deg);
  transition: all 0.5s ease;
}
.register-btn:hover::after {
  left: 200%;
}

@media (max-width: 768px) {
  .custom-table th, .custom-table td { padding: 8px; font-size: 0.9rem; }
}
@media (max-width: 480px) {
  .custom-table th, .custom-table td { padding: 6px; font-size: 0.8rem; }
}
</style>
